import { useMemo } from "react";
import { IFormSatisfaction } from "../../../models/form-satisfaction";
import { useEvaluationFormContext } from "../../../store/contexts/EvaluationFormContext";
import { FormSucceeded } from "./FormSucceeded";

interface IFormSucceededContainerProps {
  evaluationForm: IFormSatisfaction["evaluationForm"];
  onGoToStart: () => void;
  onResetInitialStep: () => void;
}

export const FormSucceededContainer = ({
  evaluationForm,
  onGoToStart,
  onResetInitialStep,
}: IFormSucceededContainerProps) => {
  const { answers: activeAnswers } = useEvaluationFormContext();

  const answers = useMemo(
    () =>
      activeAnswers.map(({ answer }) => ({
        answer: answer ?? "",
      })),
    [activeAnswers],
  );

  return (
    <FormSucceeded
      answers={answers}
      evaluationForm={evaluationForm}
      onGoToStart={onGoToStart}
      onResetInitialStep={onResetInitialStep}
    />
  );
};
